<template>
    <div class="general">
        <div class="testStudent-body collection testStudent-body-mobile collection-mobile">
            <h2>Сбор анамнеза</h2>
            <p>Ознакомьтесь с анамнезом пациента и отметьте патологию</p>
            <div class="collection-container">
                <h3>Анамнез жизни</h3>
                <v-skeleton-loader v-if="loading" type="list-item-two-line" />
                <div
                    class="collection-item"
                    v-for="(item, index) in getAnamnes.array.filter((f) => f.anamnesType === 1)"
                    :key="'a'+index"
                    :class="{'chooseEl': item.isPathology}"
                    v-show="!loading"
                >
                    <span @click.prevent="selectedPatalogy(item)">{{ item.anamnesText }}</span>
                </div>

                <h3>Анамнез заболевания</h3>
                <v-skeleton-loader v-if="loading" type="list-item-two-line" />
                <div
                    class="collection-item"
                    v-for="(item, index) in getAnamnes.array.filter((f) => f.anamnesType === 2)"
                    :key="'b'+index"
                    :class="{'chooseEl': item.isPathology}"
                    v-show="!loading"
                >
                    <span @click.prevent="selectedPatalogy(item)">{{ item.anamnesText }}</span>
                </div>
            </div>
        </div>

        <div class="button d-flex justify-end mt-8">
            <slot name="btn" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
    name:'Collection',
    computed: {
        ...mapGetters({
            getAnamnes: 'takeDiagnosticTest/getAnamnes',
            getFirstStepOrNot: 'takeDiagnosticTest/getFirstStepOrNot'
        })
    },
    data: () => ({
        loading: true,
    }),
    methods: {
        ...mapActions({
            getAnamnesis: 'takeDiagnosticTest/getAnamnesis',
            sendAnamnesAnswer: 'takeDiagnosticTest/sendAnamnesAnswer',
            getSections: 'takeDiagnosticTest/getSections'
        }),
        ...mapMutations({
            changeViewPage: 'takeDiagnosticTest/changeViewPage',
            checkingFirstStep: 'takeDiagnosticTest/checkingFirstStep'
        }),
        selectedPatalogy(item) {
            item.isPathology = !item.isPathology

            this.sendAnamnesAnswer({ processId: this.$route.params.id, answerAnamnesId: item.id, isPathology: item.isPathology })
        }
    },
    created() {
        this.getSections(this.$route.query.diaTestId)
            .then(() => {
                this.changeViewPage('Сбор анамнеза');
                this.checkingFirstStep();

                if(this.getFirstStepOrNot) {
                    this.introJS.setOptions({
                        steps: [
                            {
                                element: document.querySelector('.intro-info'),
                                intro: 'Обратите внимание на показатели пациента!',
                                position: 'bottom'
                            }
                        ]
                    }).start();
                }
            })
        this.getAnamnesis(this.$route.params.id)
            .then(() => {
                this.loading = false;
            })
    }
}
</script>

<style scoped>
@media screen and (max-width: 500px) {
    .testStudent-body {
        display: none;
    }
}

@media screen and (min-width: 501px) {
    .testStudent-body-mobile{
        display: none;
    }
}
</style>
